import { render, staticRenderFns } from "./ReceiveOrder.vue?vue&type=template&id=49de14c0&scoped=true"
import script from "./ReceiveOrder.vue?vue&type=script&lang=js"
export * from "./ReceiveOrder.vue?vue&type=script&lang=js"
import style0 from "./ReceiveOrder.vue?vue&type=style&index=0&id=49de14c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de14c0",
  null
  
)

export default component.exports